import React from "react";
import { Flex, HStack, Text, Icon, Spacer, Divider, useColorModeValue } from "@chakra-ui/react";
import { WiStrongWind } from "react-icons/wi";
import { weatherCodeToIcon } from "../../utils/weatherIconUtils";

interface TableForecastWidgetProps {
  dateStr: string;
  weatherCode: number;
  tMax: string;
  wMax: string;
  isLast?: boolean;
}

const TableForecastWidget: React.FC<TableForecastWidgetProps> = ({
  dateStr,
  weatherCode,
  tMax,
  wMax,
  isLast,
}) => {
  const dt = new Date(dateStr);
  const day = dt.toLocaleDateString("en-GB", {
    weekday: "short",
    day: "numeric",
    month: "short",
  });

  const IconWeather = weatherCodeToIcon[weatherCode] || weatherCodeToIcon[0];
  const textColor = useColorModeValue("black", "white");

  return (
    <>
      <Flex align="center" py={3}>
        <HStack spacing={3}>
          <Text w="90px" color={textColor}>
            {day}
          </Text>
        </HStack>

        <Spacer />

        <HStack spacing={1} ml={5}>
          <Icon as={IconWeather} boxSize={5} ml={5} />
          <Text fontWeight="medium">{tMax}°</Text>
        </HStack>

        <Spacer />

        <HStack spacing={1}>
          <Icon as={WiStrongWind} boxSize={4} />
          <Text fontSize="sm" color={textColor}>
            {wMax} m/s
          </Text>
        </HStack>
      </Flex>

      {!isLast && <Divider borderColor="dark" borderBottomWidth="1.5px" ml={0} mr={0} />}
    </>
  );
};

export default TableForecastWidget;
